// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountNavigationListStyles } from "@awc/App/Widgets/MyAccount/MyAccountNavigationList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

myAccountNavigationListStyles.link = {
    typographyProps: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.small};
        `,
    },
};

myAccountNavigationListStyles.separator = {
    css: css`
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

myAccountNavigationListStyles.mobileNavWrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 16px;
    `,
};
